import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useState } from 'react';

import UzbFlag from 'assets/img/icons/uzb-flag.svg';
import RussianFlag from 'assets/img/icons/russian-flag.svg';
import styles from './style.module.scss';
import { useAppContext } from 'providers/AppProvider';

const languages = [
  { slug: 'ru', title: 'russian', icon: RussianFlag },
  { slug: 'uz', title: 'uzbek', icon: UzbFlag }
];

const SettingsLanguages = () => {
  const { t, i18n } = useTranslation();

  const {
    config: { theme }
  } = useAppContext();

  const [selectedLang, setSelectedLang] = useState(i18n.language);

  const handleChangeLanguage = (lang: string) => {
    setSelectedLang(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <div className="setting-panel-item mt-0">
      <h5 className="setting-panel-item-title">{t('language')}</h5>
      <div className={styles.languageContainer}>
        {languages.map(language => (
          <label key={language.slug} className={styles.languageItem}>
            <Form.Check
              type="radio"
              name="language"
              value={language.slug}
              checked={selectedLang === language.slug}
              onChange={() => handleChangeLanguage(language.slug)}
              className={styles.radioInput}
            />
            <img
              src={language.icon}
              alt={language.title}
              className={styles.languageIcon}
            />
            <span
              style={{ color: `${theme === 'dark' ? '#9fa6bc' : '#000'}` }}
              className={styles.languageLabel}
            >
              {t(language.title)}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default SettingsLanguages;
